const postVueObject = {
    el: '#general-overview-vue',
    data: function () {
        // Initial posts are rendered server-side and passed along as inline JSON,
        // so the first paint doesn't depend on the AJAX request completing.
        const initialDataEl = document.getElementById('general-overview-initial-data');
        const initialData = initialDataEl ? JSON.parse(initialDataEl.textContent) : {};
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
        }, 100);
        return {
            posts: initialData.posts || [],
            posts_no_filter: [],
            foundPosts: initialData.found_posts || 0,
            unseenPosts: 0,
            foundPages: initialData.max_num_pages || 0,
            loadingPosts: false,
            postType: '',
            taxonomies: initialData.taxonomies || [],
            activeTerms: initialData.active_terms || {},
            cardTaxonomy: initialData.card_taxonomy || '',
            openDropdown: null,
            postsPerPage: initialData.posts_per_page || 7,
            step: 6
        };
    },
    methods: {
        loadPosts() {
            this.loadingPosts = true;
            let params = {
                post_type: this.postType,
                taxonomies: this.activeTerms,
                card_taxonomy: this.cardTaxonomy,
                posts_visible: this.postsPerPage
            };

            const formData = new FormData();
            formData.append('action', 'get_blogposts');
            formData.append('data', JSON.stringify(params));

            axios.post(wp_ajax.ajax_url, formData).then(
                (response) => {
                    if (response.data) {
                        const result = response.data;

                        this.foundPosts = result.found_posts;
                        this.foundPages = result.max_num_pages;
                        this.loadingPosts = false;
                        this.posts = result.posts;

                        setTimeout(() => {
                            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
                        }, 100);
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        },
        toggleDropdown(taxonomy) {
            this.openDropdown = this.openDropdown === taxonomy ? null : taxonomy;
        },
        closeDropdowns() {
            this.openDropdown = null;
        },
        toggleTerm(taxonomy, termSlug) {
            if (!taxonomy || !termSlug) {
                return;
            }

            const current = this.activeTerms[taxonomy] ? [...this.activeTerms[taxonomy]] : [];
            const termIsPresent = current.includes(termSlug);

            this.removeURLSearchParam(taxonomy);

            if (termIsPresent) {
                Vue.set(this.activeTerms, taxonomy, []);
            } else {
                Vue.set(this.activeTerms, taxonomy, [termSlug]);
                this.appendURLSearchParam(taxonomy, termSlug);
            }

            this.loadPosts();
        },
        clearTaxonomyTerms(taxonomy) {
            if (!taxonomy) {
                return;
            }

            Vue.set(this.activeTerms, taxonomy, []);
            this.removeURLSearchParam(taxonomy);
            this.loadPosts();
        },
        appendURLSearchParam(key, value) {
            const url = new URL(window.location.href);
            const currentValues = url.searchParams.getAll(key);
            // if needs to be able to select more than 1
            const urlContainsValue = currentValues.includes(value);

            if (!urlContainsValue) {
                url.searchParams.append(key, value);
                window.history.pushState({ path: url.href }, '', url.href);
            }
        },
        removeURLSearchParam(key, valueToRemove) {
            const url = new URL(window.location.href);
            const currentValues = url.searchParams.getAll(key);

            if (key && !valueToRemove) {
                url.searchParams.delete(key);
                window.history.pushState({ path: url.href }, '', url.href);
                return;
            }
            const newValues = currentValues.filter((value) => {
                return value !== valueToRemove;
            });
            url.searchParams.delete(key);
            newValues.forEach((value) => {
                url.searchParams.append(key, value);
            });
            window.history.pushState({ path: url.href }, '', url.href);
        }
    },
    mounted: function () {
        Vue.nextTick(() => {
            const rootElement = this.$el;

            this.postType = rootElement.dataset.postType;

            document.addEventListener('click', (e) => {
                if (this.openDropdown && !rootElement.contains(e.target)) {
                    this.closeDropdowns();
                }
            });

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    this.closeDropdowns();
                }
            });
        });
    }
};

const isPagePost = document.querySelectorAll('#general-overview-vue').length >= 1;
if (isPagePost) {
    // Vue.config.ignoredElements = ['h1', 'sentence', 'line', 'word', 'letter'];
    window.postVueApp = new Vue(postVueObject);
}
